export default __webpack_public_path__ + "static/media/Eleven.d719f976.svg";